// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"7b5e7eac","311":"fbcb991c"}[chunkId] + ".chunk.js";
};